import { render, staticRenderFns } from "./TeacherTag.vue?vue&type=template&id=05a86cb4&scoped=true&"
import script from "./TeacherTag.vue?vue&type=script&lang=js&"
export * from "./TeacherTag.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTag.vue?vue&type=style&index=0&id=05a86cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a86cb4",
  null
  
)

export default component.exports